import React, { useContext } from 'react';
import { Modal } from 'antd';
import DefaultLayout from '../../DefaultLayout/DefaultLayout';
import ContentBox from '../../common/ContentBox/ContentBox';
import useAppearenceHook from './Appearence.hook';
import AppButton from '../../common/Forms/AppButton/AppButton';
import ColorInput from '../../common/Forms/Inputs/ColorInput/ColorInput';
import styles from './Appearence.styles';
import ImageInput from '../../common/Forms/Inputs/ImageInput/ImageInput';
import Loading from '../../common/Loader/Loading';
import { AppContext } from '../../../App.context';
import InfoView from 'Components/common/InfoView/InfoView';
import { InfoCircleOutlined, EyeFilled } from '@ant-design/icons';
import SaveButton from 'Components/common/SaveButton/SaveButton';
import ImageSlider from './ImageSlider/ImageSlider';
import PreviewCheckinAppearance from './Modals/PreviewCheckinAppearance';
import PreviewPaperlessAppearance from './Modals/PreviewPaperlessApearance';
import PreviewChainAppearance from './Modals/PreviewChainAppearance';
import HotelsEditor from './HotelsEditor/HotelsEditor';

export default function Appearence() {
  const {
    appState,
    appActions: { translate },
  } = useContext(AppContext);
  const { state, actions } = useAppearenceHook();
  const MODAL_WIDTH = 900;

  return (
    <DefaultLayout title={translate('layout.appearence')}>
      <ContentBox title={translate('appearence.checkInTitle')}>
        {state.isLoading || !appState?.hotelList?.length ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {state.isLoading ? (
              <Loading />
            ) : (
              <InfoView text={translate('emptyHotelListError')} icon={<InfoCircleOutlined />} />
            )}
          </div>
        ) : (
          <div style={styles.flexColumn}>
            <ImageInput
              name={translate('appearence.logo')}
              value={state.logo}
              setValue={actions.updateValue}
              id={'logo'}
              hotelId={state.hotel?.key}
              type={'normal'}
              disabled={!state.userCanEdit}
            />
            <ColorInput
              name={translate('appearence.mainColor')}
              value={state.color1}
              setValue={actions.updateValue}
              id={'color1'}
            />
            <ColorInput
              name={translate('appearence.secondaryColor')}
              value={state.color2}
              setValue={actions.updateValue}
              id={'color2'}
            />
            <ColorInput
              name={translate('appearence.bgColor')}
              value={state.bgColor}
              setValue={actions.updateValue}
              id={'bgColor'}
            />
            <div style={styles.previewButton}>
              <AppButton
                secondary
                action={() => actions.changeActivePreview('hotelActivePreview', true)}
                text={translate('legalDocuments.previewBtn')}
                icon={<EyeFilled style={{ color: '#708393' }} />}
              />
            </div>
            <div style={styles.buttonContainer}>
              <SaveButton
                text={translate('appearence.apply')}
                hidden={!state.userCanEdit}
                action={actions.updateApearence}
              />
            </div>
            <HotelsEditor
              currentHotel={state.hotel}
              appearanceData={'checkinOnline'}
              onCopyToHotels={actions.copyToHotels}
              label={translate('appearence.applyAppearenceHotels').replace('%s', 'Check-in Online')}
              labelSave={translate('save')}
              hidden={!state.userCanEdit}
            />
          </div>
        )}
      </ContentBox>

      <ContentBox title={translate('appearence.chainTitle')}>
        {state.isLoading || !appState?.hotelList?.length ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {state.isLoading ? (
              <Loading />
            ) : (
              <InfoView text={translate('emptyHotelListError')} icon={<InfoCircleOutlined />} />
            )}
          </div>
        ) : (
          <div style={styles.flexColumn}>
            <ImageInput
              name={translate('appearence.logo')}
              value={state.chainLogo}
              setValue={actions.updateValue}
              id={'chainLogo'}
              chainId={state.chainId}
              disabled={!state.userCanEdit}
            />
            <ColorInput
              name={translate('appearence.mainColor')}
              value={state.chainColor1}
              setValue={actions.updateValue}
              id={'chainColor1'}
            />
            <ColorInput
              name={translate('appearence.secondaryColor')}
              value={state.chainColor2}
              setValue={actions.updateValue}
              id={'chainColor2'}
            />
            <ColorInput
              name={translate('appearence.bgColor')}
              value={state.chainBgColor}
              setValue={actions.updateValue}
              id={'chainBgColor'}
            />

            <div style={styles.previewButton}>
              <AppButton
                secondary
                action={() => actions.changeActivePreview('chainActivePreview', true)}
                text={translate('legalDocuments.previewBtn')}
                icon={<EyeFilled style={{ color: '#708393' }} />}
              />
            </div>
            <div style={styles.buttonContainer}>
              <AppButton
                text={translate('appearence.apply')}
                action={() => actions.updateChain()}
                hidden={!state.userCanEdit}
              />
            </div>
          </div>
        )}
      </ContentBox>

      <ContentBox title={translate('appearence.kioskTitle')}>
        {state.isLoading || !appState?.hotelList?.length ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {state.isLoading ? (
              <Loading />
            ) : (
              <InfoView text={translate('emptyHotelListError')} icon={<InfoCircleOutlined />} />
            )}
          </div>
        ) : (
          <div style={styles.flexColumn}>
            <ImageInput
              name={translate('appearence.kioskLogo')}
              value={state.kioskLogo}
              setValue={actions.updateValue}
              id={'kioskLogo'}
              hotelId={state.hotel?.key}
              type={'kiosk'}
              disabled={!state.userCanEdit}
            />
            <ColorInput
              name={translate('appearence.mainColorKiosk')}
              value={state.kioskTitleColor}
              setValue={actions.updateValue}
              id={'kioskTitleColor'}
            />
            <ColorInput
              name={translate('appearence.kioskBg')}
              value={state.kioskBgColor}
              setValue={actions.updateValue}
              id={'kioskBgColor'}
            />
            <div style={styles.previewButton}>
              <AppButton
                secondary
                action={() => actions.changeActivePreview('paperlessActivePreview', true)}
                text={translate('legalDocuments.previewBtn')}
                icon={<EyeFilled style={{ color: '#708393' }} />}
              />
            </div>
            <div style={styles.buttonContainer}>
              <SaveButton
                text={translate('appearence.apply')}
                action={actions.updateKiosk}
                hidden={!state.userCanEdit}
              />
            </div>
            <HotelsEditor
              currentHotel={state.hotel}
              appearanceData={'kiosk'}
              onCopyToHotels={actions.copyToHotels}
              label={translate('appearence.applyAppearenceHotels').replace('%s', 'Kiosk')}
              labelSave={translate('save')}
              hidden={!state.userCanEdit}
            />
          </div>
        )}
      </ContentBox>

      {state.paperlessVersion === 'v2' || state.hotel?.key === 4941 ? (
        <ContentBox title={translate('appearence.imageSliderTitle')}>
          {state.isLoading ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {state.isLoading ? (
                <Loading />
              ) : (
                <InfoView text={translate('emptyHotelListError')} icon={<InfoCircleOutlined />} />
              )}
            </div>
          ) : (
            <ImageSlider images={state.sliderImages} hotel={state} />
          )}
        </ContentBox>
      ) : null}

      {/* hotel, preview */}
      <Modal
        open={state.hotelActivePreview}
        onCancel={() => actions.changeActivePreview('hotelActivePreview', false)}
        footer={null}
        width={MODAL_WIDTH}
        closable={false}
      >
        <PreviewCheckinAppearance
          customStyles={{
            textAndBorderColor: actions.formatColor(state.color1),
            backgroundColor: actions.formatColor(state.bgColor),
            buttonColor: actions.formatColor(state.color2),
          }}
          logoImage={state?.logo || null}
        />
      </Modal>
      {/* Chain preview */}
      <Modal
        open={state.chainActivePreview}
        onCancel={() => actions.changeActivePreview('chainActivePreview', false)}
        footer={null}
        width={MODAL_WIDTH}
        closable={false}
      >
        <PreviewChainAppearance
          customStyles={{
            textAndBorderColor: actions.formatColor(state.chainColor1),
            backgroundColor: actions.formatColor(state.chainBgColor),
            buttonColor: actions.formatColor(state.chainColor2),
          }}
          logoImage={state.chainLogo || null}
        />
      </Modal>

      {/* Kiosk preview */}
      <Modal
        open={state.paperlessActivePreview}
        onCancel={() => actions.changeActivePreview('paperlessActivePreview', false)}
        footer={null}
        width={MODAL_WIDTH}
        closable={false}
      >
        <PreviewPaperlessAppearance
          customStyles={{
            backgroundColor: actions.formatColor(state.kioskBgColor),
            sectionTitleColor: actions.formatColor(state.kioskTitleColor),
            secondaryColor: actions.formatColor(state.color2),
          }}
          logoImage={state.kioskLogo || null}
        />
      </Modal>
    </DefaultLayout>
  );
}
